import _ from 'lodash';
import constants from '../../helpers/constants';
import helpers from './helpers';

export default {
  getAllResources: state => state.data,

  getResourceById: state => resourceId => state.data.find(o => o.id === +resourceId),

  getResourcesByProjectId: (state, getters, rootState) => projectId => state.data.filter(resourceData => resourceData.resourceProjects.find(o => o.projectId === projectId)),

  getResourcesByProjectIdAndType: (state, getters, rootState) => (projectId, type) => state.data.filter(resourceData => resourceData.resourceProjects.find(o => o.projectId === projectId && o.type === type)),

  getResourcesByProjectIdsAndType: (state, getters, rootState) => (projectIds, type) => state.data.filter(resourceData => resourceData.resourceProjects.find(o => projectIds.includes(o.projectId) && o.type === type)),

  getResourcesByProjectIdForUI: (state, getters, rootState) => projectId => {
    const preparedResources = [];

    state.data.forEach(resourceData => {
      const resourceProjectData = resourceData.resourceProjects.find(o => o.projectId === projectId);

      if (resourceProjectData) {
        preparedResources.push({
          id: resourceData.id,
          userId: resourceData.userId,
          name: resourceData.name,
          value: resourceData.name,
          type: resourceProjectData.type,
          price: resourceProjectData.price,
          picture: resourceData.photo || (`${GT.cdn}/imgs/default/default-ava.svg`),
        });
      }
    });

    return _.sortBy(preparedResources, resource => resource.name.toLowerCase());
  },
  getResourcesByProjectIdsForUI: (state, getters, rootState) => projectIds => {
    const preparedResources = [];
    const resourcesProjectsMap = new Map();
    const addedResources = new Map();

    projectIds.forEach(projectId => {
      state.data.forEach(resourceData => {
        if (!resourcesProjectsMap.get(resourceData.id)) {
          resourcesProjectsMap.set(resourceData.id, _.keyBy(resourceData.resourceProjects, 'projectId'));
        }

        const resourceProjectData = resourcesProjectsMap.get(resourceData.id)[projectId];

        if (resourceProjectData && !addedResources.get(resourceData.id)) {
          preparedResources.push({
            id: resourceData.id,
            userId: resourceData.userId,
            name: resourceData.name,
            value: resourceData.name,
            type: resourceProjectData.type,
            price: resourceProjectData.price,
            picture: resourceData.photo || (`${GT.cdn}/imgs/default/default-ava.svg`),
          });
          addedResources.set(resourceData.id, true);
        }
      });
    });

    return _.sortBy(preparedResources, resource => resource.name.toLowerCase());
  },

  getResourceIdByUserId: (state, getters) => userId => {
    const resourceData = state.data.find(o => o.userId === userId);

    return resourceData?.id;
  },

  getResourceByUserId: (state, getters, rootState) => userId => state.data.find(o => o.userId === userId),

  getResourcesByTaskIdAndGanttId: (state, getters, rootState, rootGetters) => (projectId, taskId) => {
    const taskResources = rootGetters['tasksModel/getResourcesForTask'](projectId, taskId);
    const projectResources = getters.getResourcesByProjectId(projectId);
    const groupByResourceId = _.groupBy(projectResources, 'id');
    const result = [];

    taskResources.length && taskResources.forEach(taskResource => {
      const resourceData = groupByResourceId[taskResource.resource_id];

      if (resourceData) {
        result.push(...resourceData);
      }
    });

    return result;
  },

  isUserAssignedToTask: (state, getters) => (projectId, taskId) => {
    const taskResources = getters.getResourcesByTaskIdAndGanttId(projectId, taskId);
    const userResource = getters.getResourceByUserId(user.id);

    return !!taskResources.some(res => res.id === userResource.id);
  },

  // getSettingsForResource
  getResourceProjectSettings: (state, getters) => (resourceId, projectId) => {
    const resourceData = getters.getResourceById(resourceId);

    if (!resourceData) {
      return null;
    }

    return resourceData.resourceProjects?.find(o => o.projectId === +projectId);
  },

  // getAllRealResources
  getAllRealResources: (state, getters) => state.data.filter(o => !!o.userId),

  // getAllMaterialResources
  getAllMaterialResources: (state, getters) => state.data.filter(o => !o.userId),

  // getResourceByEmail
  getResourceByEmail: (state, getters) => email => state.data.find(o => o.email === email),

  // getRealResourcesByGanttId
  getRealResourcesByGanttId: (state, getters) => projectId => getters.getAllRealResources.filter(o => o.resourceProjects.find(o => o.projectId === projectId)),

  // getMaterialResourcesByGanttId
  getMaterialResourcesByGanttId: (state, getters) => projectId => getters.getAllMaterialResources.filter(o => o.resourceProjects.find(o => o.projectId === projectId)),

  // getUnaddedRealResourcesByGanttId
  getUnAddedRealResourcesByGanttId: (state, getters) => projectId => getters.getAllRealResources.filter(o => !o.resourceProjects.find(o => o.projectId === projectId)),

  // getUnaddedMaterialResourcesByGanttId
  getUnAddedMaterialResourcesByGanttId: (state, getters) => projectId => getters.getAllMaterialResources.filter(o => !o.resourceProjects.find(o => o.projectId === projectId)),

  getResourceTypeOnProject: (state, getters) => (resourceId, projectId) => {
    const resourceData = getters.getResourceById(resourceId);

    if (!resourceData) return;

    return resourceData.resourceProjects.find(o => o.projectId === projectId)?.type;
  },

  getResourcesByTypeOnProject: (state, getters) => type => state.data.filter(r => r.resourceProjects.find(rP => rP.type === type)),
};
